<div class="music-info">
   @if (!this.resetCurrentTrack() && currentTrack().title) {
    <span class="cc_streaminfo" #streaminfo>
      {{ currentTrack().title }} - {{ currentTrack().artist }} - {{ currentTrack().album }}
    </span>
    }
</div>
<button mat-button (click)="expand()"><mat-icon>open_in_new</mat-icon></button>
